import { ItemList } from "models/InputLayoutItem";

export const calculateDownPaymentPercent = (vehicleValue: number, vehicleYear: number): ItemList[] => {
	let percent;
	if (vehicleYear <= 2019) {
		percent = [30, 40, 50, 60];
	} else {
		percent = [20, 30, 40, 50, 60];
	}
	let options: ItemList[];
	options = percent.map((value) => {
		const downPayment = Math.round((value * vehicleValue) / 100);
		return {
			label: `${value}% - $ ${new Intl.NumberFormat('es-CL').format(downPayment)}`,
			value: downPayment.toString(),
		};
	});

	return options;
};